function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Clip 2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 1.00031H22.493V22.4941H1V1.00031Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.10838 19.6753C6.68838 19.6753 7.23538 19.8953 7.81438 20.1283C11.3614 21.7683 15.5564 21.0223 18.2894 18.2903C21.8954 14.6823 21.8954 8.8133 18.2894 5.2073C16.5434 3.46131 14.2214 2.50031 11.7494 2.50031C9.27638 2.50031 6.95338 3.46231 5.20838 5.20831C2.47438 7.94031 1.73038 12.1353 3.35538 15.6483C3.58938 16.2273 3.81538 16.7913 3.81538 17.3773C3.81538 17.9623 3.61438 18.5513 3.43738 19.0713C3.29138 19.4993 3.07038 20.1453 3.21238 20.2873C3.35138 20.4313 4.00138 20.2043 4.43038 20.0573C4.94538 19.8813 5.52938 19.6793 6.10838 19.6753ZM11.7244 22.4943C10.1964 22.4943 8.65838 22.1713 7.21938 21.5053C6.79538 21.3353 6.39838 21.1753 6.11338 21.1753C5.78538 21.1773 5.34438 21.3293 4.91838 21.4763C4.04438 21.7763 2.95638 22.1503 2.15138 21.3483C1.34938 20.5453 1.71938 19.4603 2.01738 18.5873C2.16438 18.1573 2.31538 17.7133 2.31538 17.3773C2.31538 17.1013 2.18238 16.7493 1.97838 16.2423C0.105376 12.1973 0.971376 7.32231 4.14838 4.14731C6.17638 2.11831 8.87538 1.00031 11.7484 1.00031C14.6214 1.00031 17.3214 2.11731 19.3494 4.14631C23.5414 8.3383 23.5414 15.1583 19.3494 19.3503C17.2944 21.4063 14.5274 22.4943 11.7244 22.4943Z",
  fill: "black"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6963 13.163C15.1443 13.163 14.6923 12.716 14.6923 12.163C14.6923 11.61 15.1353 11.163 15.6873 11.163H15.6963C16.2483 11.163 16.6963 11.61 16.6963 12.163C16.6963 12.716 16.2483 13.163 15.6963 13.163Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 6",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.6875 13.163C11.1355 13.163 10.6835 12.716 10.6835 12.163C10.6835 11.61 11.1255 11.163 11.6785 11.163H11.6875C12.2395 11.163 12.6875 11.61 12.6875 12.163C12.6875 12.716 12.2395 13.163 11.6875 13.163Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 8",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.67832 13.163C7.12632 13.163 6.67432 12.716 6.67432 12.163C6.67432 11.61 7.11732 11.163 7.66932 11.163H7.67832C8.23032 11.163 8.67832 11.61 8.67832 12.163C8.67832 12.716 8.23032 13.163 7.67832 13.163Z",
  fill: "black"
});

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _ref2), _ref3), _ref4, _ref5, _ref6)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chat.013e4b81.svg";
export { ForwardRef as ReactComponent };